import "core-js/modules/web.dom-collections.iterator.js";
import React, { forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { Typography, Drawer, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SideBarButton = _ref => {
  let {
    isOpen,
    onToggleSideBar,
    dw
  } = _ref;
  let sideBarWidth = dw || 421;
  sideBarWidth += 31; // add 31 for the padding/margins
  if (isOpen) {
    return /*#__PURE__*/_jsx(Box, {
      sx: {
        minWidth: "".concat(sideBarWidth, "px")
      },
      onClick: onToggleSideBar
    });
  }
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      cursor: 'pointer'
    },
    backgroundColor: "#002D4C",
    minWidth: 40,
    onClick: onToggleSideBar,
    children: /*#__PURE__*/_jsx(Typography, {
      color: "#D16400",
      fontWeight: "bold",
      variant: "h6",
      marginLeft: 2,
      children: ">"
    })
  });
};
SideBarButton.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  dw: PropTypes.number,
  onToggleSideBar: PropTypes.func
};

/**
 * Wrapper of the Mui Drawer component
 * Sets some base properties
 * @returns
 */
const SideBar = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    initiallyOpen,
    drawerWidth,
    children,
    title,
    aboutThisSideBarLabel,
    onAbtThisClick,
    onSideBarToggle,
    sx
  } = _ref2;
  const [checked, setChecked] = React.useState(initiallyOpen || false);

  // Expose some methods to the parent component
  useImperativeHandle(ref, () => {
    return {
      forceOpen
    };
  });
  const handleSideBarClick = () => {
    const newChecked = !checked;
    setChecked(current => !current);
    onSideBarToggle(newChecked);
  };
  const forceOpen = () => {
    setChecked(true);
  };
  const dw = drawerWidth || 421;
  const titleBoxWidth = drawerWidth - 38;
  const bg = (sx === null || sx === void 0 ? void 0 : sx.backgroundColor) || '#F1F1F1';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SideBarButton, {
      onToggleSideBar: handleSideBarClick,
      isOpen: checked,
      dw: dw
    }), /*#__PURE__*/_jsxs(Drawer, {
      sx: {
        width: {
          dw
        },
        '& .MuiDrawer-paper': {
          width: {
            dw
          },
          boxSizing: 'border-box',
          backgroundColor: bg
        }
      },
      variant: "persistent",
      anchor: "left",
      open: checked,
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          marginTop: '75px',
          height: '40px',
          marginLeft: '16px',
          marginRight: '15px',
          marginBottom: '10px',
          backgroundColor: '#fff'
        },
        children: [/*#__PURE__*/_jsx(Box, {
          sx: {
            left: 0,
            display: 'inline-flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
            height: '40px',
            width: "".concat(titleBoxWidth, "px"),
            border: '1px solid #C8C8C8'
          },
          children: /*#__PURE__*/_jsx(Typography, {
            color: "#264D6A",
            marginTop: "5px",
            fontWeight: "bold",
            fontSize: 18,
            children: title
          })
        }), /*#__PURE__*/_jsx(Box, {
          onClick: handleSideBarClick,
          sx: {
            left: 0,
            display: 'inline-flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
            height: '40px',
            width: '37px',
            border: '1px solid #C8C8C8'
          },
          children: /*#__PURE__*/_jsx(Typography, {
            color: "#D16400",
            marginTop: "5px",
            fontWeight: "bold",
            fontSize: 18,
            children: "<"
          })
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        className: "sidebar-content",
        sx: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          marginLeft: '16px',
          marginRight: '15px',
          backgroundColor: '#fff'
        },
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Box, {
            sx: {
              width: "".concat(dw, "px")
            },
            children: children
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsxs(Box, {
            onClick: onAbtThisClick,
            sx: {
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'rows',
              justifyContent: 'flex-end',
              paddingLeft: '10px',
              paddingRight: '10px',
              paddingTop: '5px',
              paddingBottom: '4px',
              marginBottom: '10px',
              alignItems: 'center'
            },
            children: [/*#__PURE__*/_jsx(Typography, {
              color: "primary",
              paddingTop: "3px",
              fontSize: "14px",
              fontWeight: "bold",
              children: aboutThisSideBarLabel
            }), /*#__PURE__*/_jsx(InfoIcon, {
              color: "secondary",
              sx: {
                marginLeft: '5px',
                paddingTop: '1px'
              }
            })]
          })
        })]
      })]
    })]
  });
});
SideBar.displayName = 'SideBar';
SideBar.propTypes = {
  initiallyOpen: PropTypes.bool.isRequired,
  drawerWidth: PropTypes.number,
  children: PropTypes.node,
  title: PropTypes.string,
  aboutThisSideBarLabel: PropTypes.string,
  onAbtThisClick: PropTypes.func,
  onSideBarToggle: PropTypes.func,
  sx: PropTypes.object
};
export default SideBar;